import { render } from "./HomeMenuOwner.vue?vue&type=template&id=ef5ba08c"
import script from "./HomeMenuOwner.vue?vue&type=script&lang=js"
export * from "./HomeMenuOwner.vue?vue&type=script&lang=js"

import "./HomeMenuOwner.vue?vue&type=style&index=0&id=ef5ba08c&lang=css"
script.render = render

export default script